import { toPlatePlugin } from '@udecode/plate/react';

import { BaseCodePlugin } from '../lib/BaseCodePlugin';

export const CodePlugin = toPlatePlugin(BaseCodePlugin);
